var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4565_214948)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7691 3.27783H8.21576C6.8642 3.27783 5.77026 4.37177 5.77026 5.72333V24.2727C5.77026 25.6242 6.8642 26.7182 8.21576 26.7182H14.6565L17.9344 29.996L21.2122 26.7182H26.7651C28.1167 26.7182 29.2106 25.6242 29.2106 24.2727V5.72333C29.2106 4.37177 28.1167 3.27783 26.7651 3.27783H26.7691Z",
    fill: "url(#paint0_linear_4565_214948)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4925 6.29019V4.8435C32.4925 2.16811 30.3244 -0.00390625 27.6451 -0.00390625H7.33592C4.66053 5.72852e-05 2.49248 2.16811 2.49248 4.84746V6.29415C1.52141 6.53196 0.800049 7.39998 0.800049 8.44239V21.5657C0.800049 22.6081 1.52141 23.4761 2.49248 23.7139V25.1606C2.49248 27.836 4.66053 30.008 7.33988 30.008H13.4675C13.6617 30.008 13.8361 29.9485 13.9748 29.8494C14.391 29.5561 14.506 28.918 14.0898 28.5018C14.0383 28.4503 13.9828 28.4067 13.9233 28.371C13.7886 28.2878 13.63 28.2442 13.4675 28.2442H7.33988C5.63556 28.2442 4.25625 26.8649 4.25625 25.1606V4.84746C4.25625 3.14314 5.63556 1.76383 7.33988 1.76383H27.649C29.3534 1.76383 30.7327 3.14314 30.7327 4.84746V25.1566C30.7327 26.8609 29.3534 28.2402 27.649 28.2402H22.4053C22.2705 28.2402 22.1397 28.272 22.0208 28.3274C21.9336 28.371 21.8504 28.4265 21.779 28.4979C21.4659 28.811 21.454 29.247 21.6443 29.568C21.7909 29.8177 22.0605 30.0001 22.4013 30.0001H27.6451C30.3205 30.0001 32.4925 27.832 32.4925 25.1527V23.706C33.4635 23.4682 34.1849 22.6001 34.1849 21.5577V8.43843C34.1849 7.39601 33.4635 6.528 32.4925 6.29019Z",
    fill: "url(#paint1_linear_4565_214948)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.4968 7.94292H9.48806C9.28196 7.94292 9.08775 7.88743 8.92524 7.79231C8.58438 7.5981 8.35449 7.22949 8.35449 6.80935C8.35449 6.53191 8.45358 6.27824 8.62005 6.08006C8.82615 5.83432 9.13927 5.67578 9.48806 5.67578H25.4928C25.8059 5.67578 26.0873 5.80261 26.2935 6.00872C26.4996 6.21482 26.6264 6.49623 26.6264 6.80935C26.6264 7.03924 26.559 7.2493 26.4441 7.42766C26.2419 7.73682 25.8931 7.94292 25.4968 7.94292Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M26.7691 3.27783H8.21582C6.86426 3.27783 5.77032 4.37177 5.77032 5.72333V24.2727C5.77032 25.6242 6.86426 26.7182 8.21582 26.7182H14.6566L17.9344 29.996L21.2123 26.7182H26.7652C28.1167 26.7182 29.2107 25.6242 29.2107 24.2727V5.72333C29.2107 4.37177 28.1167 3.27783 26.7652 3.27783H26.7691ZM28.0414 24.2766C28.0414 24.9782 27.4707 25.5489 26.7691 25.5489H20.7287L17.9344 28.3432L15.1401 25.5489H8.21582C7.51428 25.5489 6.94353 24.9782 6.94353 24.2766V5.72333C6.94353 5.02179 7.51428 4.45104 8.21582 4.45104H26.7652C27.4667 4.45104 28.0375 5.02179 28.0375 5.72333V24.2727L28.0414 24.2766ZM14.0898 28.4978C14.506 28.914 14.387 29.5521 13.9748 29.8454C13.8361 29.9445 13.6657 30.0039 13.4675 30.0039H7.33988C4.6645 30.0039 2.49248 27.8359 2.49248 25.1565V23.7099C1.52141 23.472 0.800049 22.604 0.800049 21.5616V14.8593C1.89398 15.3508 3.04737 15.7986 4.25229 16.191V25.1565C4.25229 26.8609 5.6316 28.2402 7.33592 28.2402H13.4635C13.626 28.2402 13.7846 28.2838 13.9193 28.367C13.9788 28.4027 14.0343 28.4463 14.0858 28.4978H14.0898ZM30.7327 16.191V25.1565C30.7327 26.8609 29.3534 28.2402 27.649 28.2402H22.4053C22.2705 28.2402 22.1397 28.2719 22.0208 28.3274C21.9336 28.371 21.8504 28.4265 21.779 28.4978C21.4659 28.8109 21.454 29.2469 21.6443 29.568C21.7909 29.8177 22.0605 30 22.4013 30H27.6451C30.3205 30 32.4925 27.8319 32.4925 25.1526V23.7059C33.4635 23.4681 34.1849 22.6001 34.1849 21.5577V14.8553C33.091 15.3468 31.9376 15.7947 30.7327 16.1871V16.191Z",
    fill: "url(#paint2_linear_4565_214948)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M17.4905 18.2047C13.305 18.2047 9.33354 17.6419 5.76636 16.6431V24.2729C5.76636 25.6244 6.86029 26.7184 8.21186 26.7184H14.6526L17.9304 29.9962L21.2083 26.7184H26.7612C28.1128 26.7184 29.2067 25.6244 29.2067 24.2729V16.6431C25.6395 17.6419 21.672 18.2047 17.4826 18.2047H17.4905Z",
    fill: "url(#paint3_linear_4565_214948)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8107 15.002C21.8107 12.616 19.8765 10.6818 17.4945 10.6818C15.1124 10.6818 13.1782 12.612 13.1782 15.002C13.1782 17.392 15.1084 19.3183 17.4945 19.3183C19.8805 19.3183 21.8107 17.3881 21.8107 15.002ZM21.7275 10.0952C21.3431 10.0952 21.0339 10.4083 21.0339 10.7928C21.0339 11.1772 21.3431 11.4864 21.7275 11.4864C22.112 11.4864 22.4251 11.1772 22.4251 10.7928C22.4251 10.4083 22.112 10.0952 21.7275 10.0952ZM13.9629 9.09636H21.018C22.326 9.09636 23.3922 10.1665 23.3922 11.4666V18.5256C23.3922 19.8336 22.326 20.8998 21.018 20.8998H13.9629C12.6589 20.8998 11.5888 19.8336 11.5888 18.5256V11.4666C11.5888 10.1626 12.655 9.09636 13.9629 9.09636ZM21.018 8.30762H13.9629C12.223 8.30762 10.8 9.73053 10.8 11.4705V18.5296C10.8 20.2735 12.2269 21.6925 13.9629 21.6925H21.018C22.762 21.6925 24.1809 20.2696 24.1809 18.5296V11.4705C24.1809 9.73053 22.758 8.30762 21.018 8.30762ZM14.07 15.002C14.07 13.1114 15.6039 11.5815 17.4905 11.5815C19.3771 11.5815 20.911 13.1154 20.911 15.002C20.911 16.8887 19.3811 18.4226 17.4905 18.4226C15.5999 18.4226 14.07 16.8887 14.07 15.002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4565_214948",
    x1: 8.83408,
    y1: 24.6492,
    x2: 26.345,
    y2: 5.13277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA0F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFAE0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4565_214948",
    x1: 8.83414,
    y1: 24.6493,
    x2: 26.345,
    y2: 5.13284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA0F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFAE0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4565_214948",
    x1: 0.800049,
    y1: 16.6389,
    x2: 34.1849,
    y2: 16.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA0F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFAE0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4565_214948",
    x1: 5.77032,
    y1: 23.3216,
    x2: 29.2146,
    y2: 23.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EA0F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED0CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFAE0C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4565_214948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3849,
    height: 30,
    fill: "white",
    transform: "translate(0.800049)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9bdb7feb6787e8c045e006deda703260.svg";
export { ForwardRef as ReactComponent };